import { useSidebar } from "@/components/layouts/SidebarContext";
import { Image, Tooltip } from "antd";
export interface XdiAttributionProps {
  /** Mode in which to display "Powered by XDI". */
  mode: "vertical";
}

/**
 * Visual marker denoting that this web app is developed by XDI.
 * TODO: Add horizontal mode.
 */
export const XdiAttribution = ({
  mode
}: XdiAttributionProps) => {
  const {
    isSidebarCollapsed
  } = useSidebar();
  switch (mode) {
    case "vertical":
      return <>
          <div className="flex h-16 flex-col items-center justify-center">
            <div className={`overflow-hidden text-nowrap text-xs font-normal transition-all ${isSidebarCollapsed ? "opacity-0" : "text-gray-500"}`}>
              Powered by
            </div>
            <Tooltip title={isSidebarCollapsed ? "Powered by XDI" : ""} placement="right" className={`${isSidebarCollapsed ? "-translate-y-1" : ""} transition-transform`}>
              <a href="https://xdi.systems" target="_blank" rel="noreferrer">
                <Image alt="XDI Logo" className="h-10 object-contain opacity-40 grayscale transition-all hover:opacity-100 hover:grayscale-0" preview={false} src="/xdi-logo.png" width="100%" height="2.25rem" />
              </a>
            </Tooltip>
          </div>
        </>;
  }
};